// extracted by mini-css-extract-plugin
export default {"info":"Info__info-gNtD","content":"Info__content-z_ey"};